import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation"; // If you need navigation
import { web_productivity_app } from "../../data/dummyData";

function WebProductivityApp() {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <h4>Productivity💪</h4>
        <h4>{web_productivity_app.length} Apps</h4>
      </div>
      <Swiper
        watchSlidesProgress={true}
        breakpoints={{
          // Responsive breakpoints for different screen sizes

          250: {
            slidesPerView: 2,
            spaceBetween: 70, // 1 card on small screens
            // Smaller gap on small screens
          },
          400: {
            slidesPerView: 2, // 1 card on small screens
            spaceBetween: 30, // Smaller gap on small screens
          },
          640: {
            slidesPerView: 3, // 2 cards on medium screens
            spaceBetween: 100, // Medium gap on medium screens
          },
          768: {
            slidesPerView: 3, // 2 cards on medium screens
            spaceBetween: 20, // Medium gap on medium screens
          },
        }}
        className="mySwiper"
        style={{ display: "flex", flexDirection: "row" }}
      >
        {web_productivity_app.map((web_productivity_app_data, index) => (
          <SwiperSlide
            className="edu_app_container"
            key={index}
            style={{ width: "auto" }}
          >
            <a
              href={web_productivity_app_data.urlLink} // Add the link for each app
              target="_blank" // Open in a new tab
              rel="noopener noreferrer" // Security feature for external links
            >
              <div className="card" style={{ padding: "10px" }}>
                <div className="card-image-container">
                  <img
                    src={web_productivity_app_data.images}
                    alt=""
                    style={{
                      width: "100%",
                      height: "auto",
                      borderRadius: "10px",
                    }}
                  />
                </div>
                <p className="card-title">{web_productivity_app_data.title}</p>
              </div>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default WebProductivityApp;
